const stripPrefix = (message: string, prefix: RegExp): string => message.replace(prefix, '').trim();

/** Combined message shown when neither Qualitas nor ANA returned a quote. */
export const buildCombinedQuoteError = (
  qualitasError: string | null,
  anaError: string | null,
): string => {
  const parts: string[] = [];
  if (qualitasError) parts.push(`• Qualitas: ${stripPrefix(qualitasError, /^Qualitas:\s*/i)}`);
  if (anaError) parts.push(`• ANA Seguros: ${stripPrefix(anaError, /^ANA Seguros:\s*/i)}`);
  if (parts.length === 0) {
    return 'No se pudo obtener cotización de Qualitas ni de ANA Seguros. Por favor, intenta nuevamente.';
  }
  return `No se pudo obtener cotización de ninguna aseguradora:\n\n${parts.join('\n')}`;
};

/** Single-company failure message, always naming the company. */
export const buildSingleCompanyError = (companyError: unknown, company: 'QUALITAS' | 'ANA' | 'BOTH'): string => {
  const companyName = company === 'ANA' ? 'ANA Seguros' : 'Qualitas';
  const message = companyError instanceof Error
    ? companyError.message
    : `Error al obtener cotización de ${companyName}`;
  const namesCompany = [companyName, 'ANA', 'Qualitas'].some((name) => message.includes(name));
  return namesCompany ? message : `${companyName}: ${message}`;
};
